<template>
    <v-container>
        <ValidationObserver ref="observer" v-slot="{ errors, handleSubmit }">
            <div v-show="$vuetify.breakpoint.mdAndUp">
                <v-row>
                    <v-col cols="8" sm="6">
                        <BulkOrderPadLineByLine />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <BulkOrderPadCopyPaste />
                    </v-col>
                </v-row>
            </div>
            <div v-show="!$vuetify.breakpoint.mdAndUp">
                <v-tabs grow>
                    <v-tab @click="setFormType(1)">
                        <TranslatableStringComponent
                            :tstring="{ string: 'lineByLine' }"
                        />
                    </v-tab>
                    <v-tab @click="setFormType(2)">
                        <TranslatableStringComponent
                            :tstring="{ string: 'copyAndPaste' }"
                        />
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="formType">
                    <v-tab-item value="1">
                        <BulkOrderPadLineByLine />
                    </v-tab-item>
                    <v-tab-item value="2">
                        <BulkOrderPadCopyPaste />
                    </v-tab-item>
                </v-tabs-items>
            </div>

            <div class="d-flex flex-row-reverse mb-10 px-4">
                <v-btn
                    color="primary"
                    :loading="isLoading"
                    type="submit"
                    :disabled="(disabledCheckout && !isAuthor) || findErrors(errors)"
                    @click="handleSubmit(handleClick)"
                >
                    <TranslatableStringComponent
                        :tstring="{ string: 'addToCart' }"
                    />
                </v-btn>
            </div>
        </ValidationObserver>
        <BulkOrderPadPersonalization />
        <BulkOrderPadDialog />
    </v-container>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import handleSnackbar from '~/mixins/handleSnackbar'
import BulkOrderPadLineByLine from '~/components/BulkOrderPadLineByLine.vue'
import BulkOrderPadCopyPaste from '~/components/BulkOrderPadCopyPaste.vue'
import BulkOrderPadDialog from '~/components/BulkOrderPadDialog.vue'
import BulkOrderPadPersonalization from '~/components/BulkOrderPadPersonalization.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

const { mapFields } = createHelpers({
    getterType: 'getBulkOrderPadField',
    mutationType: 'updateBulkOrderPadField',
})
export default {
    name: 'BulkOrderPad',
    components: {
        ValidationObserver,
        BulkOrderPadLineByLine,
        BulkOrderPadCopyPaste,
        BulkOrderPadDialog,
        BulkOrderPadPersonalization,
        TranslatableStringComponent,
    },
    mixins: [handleSnackbar],
    data() {
        return {
            isLoading: false,
            e1: 1,
            disabledCheckout: false,
        }
    },
    computed: {
        ...mapFields('bulkOrderPad', ['formType']),
        ...mapState('bulkOrderPad', [
            'dialog',
            'availableBulkOrderItems',
            'unAvailableItems',
        ]),
        ...mapState('cart', ['cartProducts']),
        ...mapGetters({
            selectedPns: 'bulkOrderPad/selectedPns',
            isAuthor: 'auth/isAuthor',
        }),
        cartUpdatedMessage() {
            return 'itemsAddedToCart'
        },
    },
    methods: {
        ...mapMutations('bulkOrderPad', ['addTextFieldRow']),
        setFormType(type) {
            if (type === 1) {
                this.formType = '1'
            } else {
                this.formType = '2'
            }
        },

        async handleClick() {
            this.$store.commit('bulkOrderPad/setUnavailableItems', [])
            this.$store.commit('bulkOrderPad/setStepperValue', 1)
            if (this.selectedPns.length === 0) {
                const message = 'pleaseEnterPartNumbersAndQuantity'
                this.hitSnackbar({ string: message }, null)
                return
            }
            this.isLoading = true
            await this.$store.dispatch(
                'bulkOrderPad/fetchBulkOrderItemsFromElastic'
            )
            if (
                this.availableBulkOrderItems.length !== this.selectedPns.length
            ) {
                this.$store.dispatch('bulkOrderPad/setUnavailableItems')
            }
            this.isLoading = false
            if (
                this.unAvailableItems.length > 0 ||
                this.cartProducts.length > 0
            ) {
                this.$store.commit('bulkOrderPad/setDialog', true)
                if (this.unAvailableItems.length === 0) {
                    this.$store.commit('bulkOrderPad/setStepperValue', 2)
                }
            } else {
                this.$store.dispatch(
                    'bulkOrderPad/replaceCartItemsWithBulkOrderItems'
                )
                this.hitSnackbar(
                    {
                        string: this.cartUpdatedMessage,
                        variables: [
                            {
                                var: this.availableBulkOrderItems.length,
                            },
                        ],
                    },
                    null
                )
            }
        },
        findErrors(errors) {
            return Object.values(errors).find(e => e.length > 0)?.length > 0 || false
        }
    },
}
</script>

<style></style>
